import { render, staticRenderFns } from "./gameResultLivecasinoTab.vue?vue&type=template&id=ff3c74aa&lang=pug"
import script from "./gameResultLivecasinoTab.vue?vue&type=script&lang=js"
export * from "./gameResultLivecasinoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports